import { lazyImport } from 'utils/lazyImport';
import { Navigate } from 'react-router';

// const { AccountRoutes } = lazyImport(() => import('features/account'), 'AccountRoutes');
// const { ProductRoutes } = lazyImport(() => import('features/products'), 'ProductRoutes');

export const publicRoutes = [{ path: '*', element: <Navigate to="." /> }];
